import React from 'react';
import { IconMusicNote, SortIcon } from '@trqk/components';

interface Props {
    column: SortableColumn<TrqkSong>;
}

export const MusicNoteHeader = ({ column }: Props): JSX.Element => {
    const { isSorted, isSortedDesc } = column;
    const fillColor = isSorted ? 'black' : 'tertiary-400';

    return (
        <div className="flex flex-row justify-center">
            <IconMusicNote width={20} fillColor={fillColor} addClasses="ml-6" />
            <SortIcon isSorted={isSorted} isSortedDesc={isSortedDesc} />
        </div>
    );
};
